import { render, staticRenderFns } from "./ConfirmLicense.vue?vue&type=template&id=2900f518&scoped=true&"
import script from "./ConfirmLicense.vue?vue&type=script&lang=js&"
export * from "./ConfirmLicense.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmLicense.vue?vue&type=style&index=0&id=2900f518&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2900f518",
  null
  
)

export default component.exports